import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { CopyrightComponent } from 'app/components/copyright/copyright.component';
import { StartupLogoComponent } from 'app/components/startup-logo/startup-logo.component';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'auth-confirmation-required',
    templateUrl: './confirmation-required.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        FuseAlertComponent,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        RouterLink,
        StartupLogoComponent,
        MatCheckboxModule,
        CopyrightComponent,
    ],
})
export class AuthConfirmationRequiredComponent implements OnInit {
    alert: { type: FuseAlertType; message: string } = {
        type: 'error',
        message: '',
    };

    codeForm: UntypedFormGroup;
    showAlert: boolean = false;

    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _formBuilder: UntypedFormBuilder,
        private _router: Router
    ) {}

    // ----------------------------------------------------------------------
    // @ Lifecycle hooks
    // ----------------------------------------------------------------------

    ngOnInit(): void {
        // Create the form
        this.codeForm = this._formBuilder.group({
            code: ['', Validators.required],
        });
    }

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------

    /**
     * Verify code
     */
    verifyCode(): void {
        // Return if the form is invalid
        if (this.codeForm.invalid) {
            return;
        }

        // Disable the form
        this.codeForm.disable();

        // Hide the alert
        this.showAlert = false;

        // Verify Code
        this._authService.verifyCode(this.codeForm.value).subscribe(
            () => {
                // Navigate to the redirection url. En este caso el dashboard
                this._router.navigateByUrl('/reset-password');
            },
            () => {
                // Re-enable the form
                this.codeForm.enable();

                // Reset the form
                //  this.codeForm.resetForm();

                // Set the alert
                this.alert = {
                    type: 'error',
                    message:
                        'Code does not match! Are you sure you have entered a valid code?',
                };

                // Show the alert
                this.showAlert = true;
            }
        );
    }

    /**
     * Resend the code to email
     */
    resendCode(): void {
        // Get email from Local storage
        const email = this._authService.email;

        this._authService.sendVerificationCode(email).subscribe(
            () => {
                // Set the alert
                this.alert = {
                    type: 'success',
                    message: 'Your verification code has been sent.',
                };

                // Show the alert
                this.showAlert = true;
            },
            () => {
                // Set the alert
                this.alert = {
                    type: 'error',
                    message: 'The verification code could not be send!',
                };

                // Show the alert
                this.showAlert = true;
            }
        );
    }
}
